'use client';

import {
  dispatchGetNotifications,
  dispatchGetUnreadCount,
} from '@/stores/notificationActions';
import { Popover, Transition } from '@headlessui/react';
import Typography from '@ui/Typography';
import { cx } from 'cva';
import { debounce, kebabCase, last } from 'lodash-es';
import React, { Fragment, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { API_URL } from 'utils/constants';
import ProfileAvatar from '../ProfileSelector/ProfileAvatar';
import Avatar from '../next-ui/Avatar';
import Button from '../next-ui/Button';
import AppNavMenu from './AppNavMenu';
import CommunitySelector from './CommunitySelector';
import NekiLogo from './NekiLogo';
import { NEKI_LOGO_S3_URL } from '@/constants/neki.constant';
import GuestAppBarMenu from './GuestAppBarMenu';
import useStore from '@/stores/store';
import { MdClose } from 'react-icons/md';
import Link from '../next-ui/Link';
import getQualifiedImageUrl from '@/utils/imageUrlProcessor';
import { useHomeFeedFilters } from '@/actions/feed.actions';
import { fetchUserFeedCount } from '@/actions/server.actions';
import { useIsCompanyAdmin, useIsNonProfitAdmin } from '@/hooks/useUser';
import { getAdminLoginUrl, getEnvBaseUrl } from '@/utils/stringHelpers';
import UserConnectionsDialog from './home-page-dialogs/UserConnectionsDialog';
import { DOMAIN_PREFIX_REDIRECTS } from '@/constants/orgConfig.constant';

function AppBar(props) {
  const { user } = props;

  const isNonProfitAdmin = useIsNonProfitAdmin();
  const isCompanyAdmin = useIsCompanyAdmin();
  const nekiBaseUrl = getEnvBaseUrl();
  const nekiAdminBaseUrl = getEnvBaseUrl('admin');
  const nekiAdminLoginUrl = getAdminLoginUrl(user?.email, user?.accessToken);
  const hasPublicProfile = user?.activeCommunity?.publicProfile?.enabled;
  const publicProfileSlug = user?.activeCommunity?.publicProfile?.slug;

  const setCounts = useHomeFeedFilters((state) => state.setCounts);
  const [scrolled, setScrolled] = useState(false);
  const [showConnections, setShowConnections] = useState(false);

  const getNonProfitLink = (user) => {
    const activeCommunity = user.activeCommunity;
    let slug = activeCommunity.hasPublicProfile?.enabled
      ? last(activeCommunity.publicProfile.slug?.split('/'))
      : null;

    if (!slug) {
      slug = `${kebabCase(activeCommunity?.name)}-${
        activeCommunity?.nonProfit?.id
      }`;
    }

    return `/organization/${slug}`;
  };

  const handleFetchCounts = async () => {
    const feed = await fetchUserFeedCount();
    const initialCounts = feed?.counts || {};
    setCounts(initialCounts);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    // dispatchGetUnreadCount();
    handleFetchCounts();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // useEffect(() => {
  //   if (user) {
  //     const socket = io(API_URL); // server url

  //     socket.on('connect', () => {
  //       socket.emit('join_user', user.id);
  //     });
  //     socket.on('connect_error', () => {
  //       setTimeout(() => socket.connect(), 10 * 1000);
  //     });

  //     socket.on(
  //       'message',
  //       debounce((res) => {
  //         console.log('socket message', res);
  //         const { notifications } = res.count || {};
  //         // setUnreadNotificationCount(notifications);
  //         dispatchGetNotifications();
  //         dispatchGetUnreadCount();
  //       }, 1000),
  //     );

  //     socket.on('disconnect', () => {
  //       console.log('socket disconnected');
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  const getCommunityLogoUrl = (community) => {
    if (community?.logoUrl) {
      return getQualifiedImageUrl(community.logoUrl);
    }
    return NEKI_LOGO_S3_URL;
  };

  const handleLogout = async () => {
    const loginUrl = DOMAIN_PREFIX_REDIRECTS[window.location.hostname];

    try {
      const res = await fetch('/api/session', { method: 'DELETE' });

      if (!res.ok) {
        console.error('Failed to clear session:', await res.text());
      }
    } catch (err) {
      console.error('Error during session deletion:', err);
    }

    if (loginUrl) {
      window.location.href = loginUrl;
    } else {
      window.location.href = `${nekiBaseUrl}/api/auth/logout`;
    }
  };

  return (
    <section
      className={cx(
        'sticky top-0 z-100 w-full bg-white',
        scrolled && 'shadow-lg drop-shadow-md',
      )}>
      <header className="flex h-[60px] w-full items-center justify-between px-4 lg:px-8">
        {user ? (
          <div className="flex items-center justify-start gap-4">
            <Link href="/home">
              {/* <div className="flex flex-col items-start justify-start gap-1"> */}
              {/* <Typography variant="h6" className="!text-[8px] font-medium">
                  Powered by
                </Typography> */}
              {/* <NekiLogo
                // src="/assets/images/neki-n-heart.jpg"
                src={getCommunityLogoUrl(user.activeCommunity)}
                className="!h-9"
              /> */}
              <Avatar
                src={getCommunityLogoUrl(user.activeCommunity)}
                alt={user?.activeCommunity?.name}
                profile="company"
                size="sm"
              />
              {/* </div> */}
            </Link>

            <CommunitySelector
              activeCommunity={user.activeCommunity}
              communities={user.communities}
              activeCommunityId={user.activeCommunityId}
            />
          </div>
        ) : (
          <Link href="https://neki.io">
            <NekiLogo />
          </Link>
        )}

        <div className="flex h-full items-center justify-start gap-2 lg:gap-6">
          {user && (
            <>
              <AppNavMenu
                user={user}
                avatar={user.avatar}
                name={user.fullName}
                // unReadNotifications={unreadNotificationCount}
                unReadNotifications={user.todo?.total}
              />

              <Popover className={cx('relative')}>
                {({ open, close }) => (
                  <>
                    {/* {isNonProfitAdmin ? (
                      <div className="mt-[7px] flex h-full items-center">
                        <Popover.Button className="hidden h-10 w-10 cursor-pointer flex-col items-center justify-end rounded-full text-white outline-none lg:flex">
                          <Avatar
                            src={user.avatar}
                            alt={user.fullName}
                            className="h-9 w-9"
                          />
                          <Typography
                            variant="h6"
                            className={cx(
                              'text-center text-[11px] font-normal',
                              'text-text-secondary',
                            )}>
                            Menu
                          </Typography>
                          <div className="relative h-[5px] w-full">
                            <div
                              className={cx(
                                'duration-250 absolute top-0 h-full transform bg-primary ease-in',
                                'w-0 transition-none',
                                'right-0',
                              )}></div>
                          </div>
                        </Popover.Button>
                      </div>
                    ) : (
                      <>
                        <div className="flex h-full items-center">
                          <Popover.Button className="hidden h-8 w-8 cursor-pointer flex-col items-center justify-center rounded-full border-b-[5px] border-transparent bg-text-disabled text-white outline-none lg:flex">
                            <Avatar
                              src={user.avatar}
                              alt={user.fullName}
                              className="h-8 w-8"
                            />
                          </Popover.Button>
                        </div>
                        <Popover.Overlay className="fixed inset-0 bg-black opacity-10" />
                      </>
                    )} */}

                    <div className="mt-[4px] flex h-full items-center justify-center">
                      <Popover.Button className="hidden h-10 w-[70px] cursor-pointer flex-col items-center justify-end rounded-full  text-white outline-none lg:flex">
                        <Avatar
                          src={user.avatar}
                          alt={user.fullName}
                          className="h-[32px] w-[32px]"
                        />
                        <Typography
                          variant="h6"
                          className={cx('text-center text-[10px] font-normal')}>
                          My Neki
                        </Typography>
                        {/* <div className="relative h-[5px] w-full">
                          <div
                            className={cx(
                              'duration-250 absolute top-0 h-full transform bg-primary ease-in',
                              'w-0 transition-none',
                              'right-0',
                            )}></div>
                        </div> */}
                      </Popover.Button>
                    </div>

                    <Popover.Overlay className="fixed inset-0 bg-black opacity-10" />

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1">
                      <Popover.Panel className="absolute right-0 z-10 mt-2 w-max translate-x-5 transform px-4 sm:px-0 lg:max-w-3xl">
                        <div className="overflow-hidden rounded-2xl shadow-lg">
                          <div className="relative flex flex-col gap-2 bg-white p-7">
                            <div
                              className="absolute right-0 top-0 p-2 text-gray-500"
                              onClick={close}>
                              <Button variant="icon">
                                <MdClose className="h-8 w-8 " />
                              </Button>
                            </div>

                            <div className="mt-4 flex items-center justify-start gap-8 border-b-2 p-2">
                              <ProfileAvatar
                                size="md"
                                className="scale-125 border-2 border-primary"
                              />
                              <div className="">
                                <Typography variant="h4">
                                  {user.fullName}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                  className="font-medium">
                                  {user.designation}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                  className="font-medium">
                                  {user.email}
                                </Typography>
                              </div>
                            </div>
                            <div className="flex flex-col items-start gap-2 border-b-2 p-2">
                              <Typography variant="h4">My Stuff</Typography>
                              <div className="ml-4 flex flex-col items-start gap-2">
                                <Typography
                                  variant="hyperlink"
                                  href={`${nekiBaseUrl}/profile/me?editProfile=Profile Information`}
                                  component="a"
                                  color="textSecondary"
                                  className="font-medium">
                                  Edit My Profile
                                </Typography>
                                <Typography
                                  variant="hyperlink"
                                  href={`${nekiBaseUrl}/profile/me?editProfile=Privacy Settings`}
                                  component="a"
                                  color="textSecondary"
                                  className="font-medium">
                                  Profile Settings and Privacy
                                </Typography>
                                <Typography
                                  variant="hyperlink"
                                  href={`${nekiBaseUrl}/profile/me`}
                                  component="a"
                                  color="textSecondary"
                                  className="font-medium">
                                  View My Profile
                                </Typography>
                                <Typography
                                  variant="hyperlink"
                                  onClick={() => setShowConnections(true)}
                                  component="button"
                                  color="textSecondary"
                                  className="font-medium">
                                  Connections
                                </Typography>
                                <Typography
                                  variant="hyperlink"
                                  component="button"
                                  onClick={handleLogout}
                                  color="textSecondary"
                                  className="font-medium">
                                  Sign out
                                </Typography>
                              </div>
                            </div>
                            {isNonProfitAdmin && (
                              <div className="flex flex-col items-start gap-2 p-2">
                                <Typography variant="h4">
                                  Manage{' '}
                                  {(user?.activeCommunity?.name || 'Nonprofit')
                                    .length > 15
                                    ? `${user?.activeCommunity?.name?.slice(
                                        0,
                                        15,
                                      )}...`
                                    : user?.activeCommunity?.name ||
                                      'Nonprofit'}
                                </Typography>
                                <div className="ml-4 flex flex-col items-start gap-2">
                                  <Typography
                                    variant="hyperlink"
                                    href={`${nekiBaseUrl}${getNonProfitLink(
                                      user,
                                    )}`}
                                    component="a"
                                    color="textSecondary"
                                    className="font-medium">
                                    My Nonprofit
                                  </Typography>
                                  <Typography
                                    variant="hyperlink"
                                    href={nekiAdminLoginUrl}
                                    component="a"
                                    color="textSecondary"
                                    className="font-medium">
                                    Administration
                                  </Typography>
                                  {hasPublicProfile && (
                                    <Typography
                                      variant="hyperlink"
                                      href={`${nekiBaseUrl}/${publicProfileSlug}`}
                                      component="a"
                                      color="textSecondary"
                                      className="font-medium">
                                      View Public Profile
                                    </Typography>
                                  )}
                                </div>
                              </div>
                            )}
                            {isCompanyAdmin && (
                              <div className="flex flex-col items-start gap-2 p-2">
                                <Typography variant="h4">
                                  Manage{' '}
                                  {(user?.activeCommunity?.name || 'Community')
                                    .length > 15
                                    ? `${user?.activeCommunity?.name?.slice(
                                        0,
                                        15,
                                      )}...`
                                    : user?.activeCommunity?.name ||
                                      'Community'}{' '}
                                </Typography>
                                <div className="ml-4 flex flex-col items-start gap-2">
                                  <Typography
                                    variant="hyperlink"
                                    href={nekiAdminLoginUrl}
                                    component="a"
                                    color="textSecondary"
                                    className="font-medium">
                                    Administration
                                  </Typography>
                                  {hasPublicProfile && (
                                    <Typography
                                      variant="hyperlink"
                                      href={`${nekiBaseUrl}/${publicProfileSlug}`}
                                      component="a"
                                      color="textSecondary"
                                      className="font-medium">
                                      View Public Profile
                                    </Typography>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </>
                )}
              </Popover>
            </>
          )}
          {!user && <GuestAppBarMenu />}
          {showConnections && (
            <UserConnectionsDialog
              open={showConnections}
              title="My Connections"
              onClose={() => setShowConnections(false)}
            />
          )}
        </div>
      </header>
    </section>
  );
}

export default AppBar;
